import * as React from "react";
import { forwardRef } from "react";
const SvgLine = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 23, viewBox: "0 0 21 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.5 0V18C0.5 20.2091 2.29086 22 4.5 22H20.5", stroke: "#CCCCCC" }));
const ForwardRef = forwardRef(SvgLine);
export default ForwardRef;
